import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'

interface AdminRouteProps {
  children: React.ReactNode
}

export function AdminRoute({ children }: AdminRouteProps) {
  const { isAdmin, authEnabled } = useAuthStore()

  // Allow access if admin OR if auth is disabled (for local development)
  if (isAdmin || !authEnabled) {
    return <>{children}</>
  }

  // Redirect non-admins to dashboard
  return <Navigate to="/" replace />
}

interface ManagerRouteProps {
  children: React.ReactNode
}

export function ManagerRoute({ children }: ManagerRouteProps) {
  const { isAdmin, isSalesManager, authEnabled } = useAuthStore()

  // Allow access if admin, sales_manager, OR if auth is disabled (for local development)
  if (isAdmin || isSalesManager || !authEnabled) {
    return <>{children}</>
  }

  // Redirect non-managers to dashboard
  return <Navigate to="/" replace />
}
